import searchWeb from "./searchweb";

import { combineReducers } from "redux";

const rootReducer = combineReducers({
  searchWeb,
});
export default rootReducer;
